<div>
  <h3>{{'news'|translate}}</h3>
  <div>
    <s-table #table [cols]="cols" [refreshUrl]="refreshUrl" [resizable]="false" [hideSearch]="true">
    </s-table>
  </div>
</div>
